import SearchableMenu from 'components/SearchableMenu';
import { useState, useEffect } from 'react';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

export const SingleSelectedMenu = ({
  itemsList,
  buttonTitle,
  selectedItem,
  setSelectedItem
}) => {
  const [anchorEl, setAnchorEl] = useState();
  const [searchFilterValue, setSearchFilterValue] = useState();
  const [searchResultItemsList, setSearchResultItemsList] = useState(itemsList);

  useEffect(() => {
    setSearchResultItemsList(itemsList);
  }, [itemsList]);

  const onSearch = searchValue => {
    const filtered = itemsList.filter(({ title }) =>
      title.toLowerCase().includes(searchValue.toLowerCase())
    );
    setSearchResultItemsList([...filtered]);
  };

  const onItemClick = item => {
    setSelectedItem(item);
    closeMenu();
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setSearchResultItemsList(itemsList);
  };

  const menuItems = searchResultItemsList?.map(item => ({
    ...item,
    onClick: () => onItemClick(item)
  }));

  return (
    <>
      <LBButton
        variant='outline'
        size='lg'
        data-testid='add-filters-button'
        onClick={e => {
          setAnchorEl(e.currentTarget);
        }}
      >
        {selectedItem?.title || buttonTitle}
        <Icon color={'chambray'} name='KeyboardArrowDown' />
      </LBButton>
      <SearchableMenu
        onSearch={onSearch}
        isSearchable
        maxSelectedCheckboxes={5}
        menuItems={menuItems}
        searchFilterValue={searchFilterValue}
        setSearchFilterValue={setSearchFilterValue}
        anchorEl={anchorEl}
        actions={[
          /* eslint-disable react/jsx-key */
          <LBButton onClick={closeMenu} variant='outline'>
            Close
          </LBButton>
          /* eslint-enable react/jsx-key */
        ]}
        width={'20rem'}
      />
    </>
  );
};
